import { API_ENDPOINTS } from "../models/Constants";
import axios from 'axios';
import { ContactRequest } from "../models/ContactRequest";
import { ContactResponse } from "../models/ContactResponse";
import { SendQuizRequest } from "../models/SendQuizRequest";
import { SendQuizResponse } from "../models/SendQuizResponse";

class HttpClient {


  async get<T>(endpoint: string): Promise<T> {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`);
    if (!response.ok) {
      throw new Error(`GET ${endpoint} failed: ${response.status}`);
    }
    return response.json();
  }

  async ping(){

    const pingUrl = `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.PING}`

     axios.get(pingUrl)
      .then((response) => {
        console.log(response.data); 
      })
      .catch((error) => {
        console.error('Error calling /ping:', error);
      });
  }

    async postContactMessage(body: ContactRequest): Promise<ContactResponse> {

        const postContactMessageUrl = `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.CONTACT}`

        console.log("Sending contact message: " + postContactMessageUrl)

        try {
            const response = await axios.post(postContactMessageUrl, body);
            return response.data;
        } catch (error) {
            console.error(`Error calling ${API_ENDPOINTS.CONTACT}:`, error);
            return { success: false, message: "Message failed to send." } as ContactResponse;
        }
    }
    
    async postSendQuizResultMessage(body: SendQuizRequest): Promise<SendQuizResponse> {
        
      const postSendQuizResultMessageUrl = `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.SEND_QUIZ_RESULT}`

      console.log("Sending contact message: " + postSendQuizResultMessageUrl)

      try {
            const response = await axios.post(postSendQuizResultMessageUrl, body);
            return response.data;
        } catch (error) {
            console.error(`Error calling ${API_ENDPOINTS.SEND_QUIZ_RESULT}:`, error);
            return { success: false, message: "Message failed to send." } as ContactResponse;
        }
    }
}

export default HttpClient